var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"banner",class:{ filled: _vm.isFilled },attrs:{"id":_vm.bannerType}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }